// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__r63M6","container":"Modal_container__Ha+Ky","close":"Modal_close__V34Fj"};